import styled from 'styled-components';

export const TabsHeader = styled.ul`
  background-color: ${({ theme }) =>
    theme.darkMode ? theme.unify.colors.white : theme.unify.colors.black};
  color: ${({ theme }) => theme.unify.colors.black};
  list-style-type: none;
  display: flex;
  padding: ${({ theme }) => theme.unify.spacing.xs};
  border-radius: ${({ theme }) => theme.unify.borderRadius.md};
  width: fit-content;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-weight: ${({ theme }) => theme.unify.typography.header.fontWeight};
  :hover {
    cursor: pointer;
  }
  @media (max-width: 470px) {
    width: 361px;
  }
`;

export const AhaContainer = styled.div`
display: flex;
justify-content: right;
flex:1;
text-align:right;
@media (max-width: 810px) {
  .right {
    display: none;
  }
}`;

export const EmptyContainer = styled.div`
  flex:1;
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative
`;

export const Tab = styled.li<{ active: boolean; name: string }>`
  padding: 8px 24px;
  border-radius: ${({ theme }) => theme.unify.borderRadius.sm};
  max-height: 19px;
  background: ${({ theme, active }) =>
    active && theme.darkMode
      ? theme.unify.colors.black
      : active && theme.unify.colors.white};
  color: ${({ theme, active }) =>
    theme.darkMode
      ? active && theme.unify.colors.white
      : active
        ? theme.unify.colors.black
        : theme.unify.colors.white};
  @media (max-width: 500px) {
        padding: 8px 1px 8px 16px;
        width: ${({ name }) =>
    name === 'myUnify' ? '96px' :
      name === 'applications' ? '103px' :
        name === 'workflows' ? '130px' :
          'auto'};
      }
   :focus {
  outline: 0px solid grey;
  outline-offset: 0px;
  background: lightgrey;
}
`;

export const AivaTabText = styled.span`
  padding-left: 4px;
`

export const TabAdoptEaseRedDot = styled.div`
   width: 15px;
    position: relative;
    top: -28px;
    left: 95px;

     @media (max-width: 500px) {
     top: -25px;
      left: 80px;
}
       @media (max-width: 470px) {
     top: -24px;
      left: 80px;
}
`;
